import { DI } from '../../../../apps/crossword-maker/src/shared/di';
import { IUpdateCrosswordBookWordDto } from '../../Api/CrosswordBook/CrosswordBook.api.types';

export const UpdateCrosswordBookWordUseCase = () => {
    const CrosswordBookRepository = DI.resolve('CrosswordBookRepository');

    return {
        async execute(id: string, data: IUpdateCrosswordBookWordDto) {
            return await CrosswordBookRepository.updateWord(id, data);
        }
    }
}
